import {Response} from '@/types/API'
import {HomeData} from '@/types/API'
import Server from '../index'


class HomeAllData{
    getData(id?: number) {
        return Server.request<Response<HomeData>>({
            url: '/api/patentzj/largeScreen',
            method: 'GET',
            params: {
                id
            }
        })
    }
}

export default new HomeAllData()